import React from 'react';
import { useQuery } from '@apollo/client';

import { FindData } from '../../pages/Find/types';
import { ImageMasonry } from './ImageMasonry';
import { FormattedMessage } from 'react-intl';

// cloudflare api token 1e_LnO8Iwr-tRkTcAsUuzOoM4DOialrScPXHMszv

const FindImages = React.memo(
  ({ called, loading, find, findId, forSite }: FindData) => {
    if (loading) {
      return (
        <div>
          <FormattedMessage id="loading" defaultMessage="Loading…" />
        </div>
      );
    }

    return (
      <>
        {called && !loading && !find && (
          <div>
            <FormattedMessage
              id="find.notFound"
              defaultMessage="Find not found"
            />
          </div>
        )}
        {called && find && find?.amcrData?.images && (
          <ImageMasonry images={find?.amcrData?.images} />
        )}
      </>
    );
  }
);

export { FindImages };
